import React, { useState, useLayoutEffect } from "react";
import { Router, useParams } from "react-router-dom";

const CustomRouter = ({ history, ...props }) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location
  });

  const params = useParams();
  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      {...props}
      location={state.location}
      navigationType={state.action}
      navigator={history}    
      params={params}  
      // 
    />
  );
};

export default CustomRouter;